module.exports = __webpack_public_path__ + "media/images/trash-6435528b8a896af73af6d8989cf7f1ff.svg";